<template>
    <div>
        <v-divider />
        <v-card color="transparent" elevation="0" class="py-6">
            <v-row>
                <v-col cols="12" md="4">
                    <v-row>
                        <v-col cols="12">
                            <v-card-title class="pa-0 black--text">
                                충전금액
                            </v-card-title>
                        </v-col>
                        <v-col cols="12">
                            <v-divider v-if="$vuetify.breakpoint.width < 768" />
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="8">
                    <v-row>
                        <template v-for="item in prices">
                            <v-col cols="12" :key="item.title">
                                <v-card-text class="pa-0">
                                    <v-row>
                                        <v-col cols="auto"> {{ item.title }} </v-col>
                                        <v-spacer />
                                        <v-col cols="auto"> {{ item.value }} </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-col>
                        </template>
                        <v-col cols="12">
                            <v-divider />
                        </v-col>
                        <v-col cols="12">
                            <v-card-text class="pa-0 font-weight-bold">
                                <v-row class="primary--text">
                                    <v-col cols="auto"> 충전 상품권 금액 </v-col>
                                    <v-spacer />
                                    <v-col cols="auto"> {{ gainable.format() }}원 </v-col>
                                </v-row>
                            </v-card-text>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
        <v-divider />
    </div>
</template>

<script>
import { initNshopOrder } from "@/store/nshop";

/** @typedef {import('@/store/nshop').NshopOrder} NshopOrder */

export default {
    components: {},
    props: {
        /** @type {import('vue').PropType<NshopOrder>} */
        value: { type: Object, default: initNshopOrder },
    },
    computed: {
        isGained() {
            return this.value.pins.reduce((sum, item) => (item.isGained ? (sum += item.faceamt) : sum), 0);
        },
        gainable() {
            return this.value.pins.reduce((sum, item) => (item.isGained ? sum : (sum += item.faceamt)), 0);
        },
        prices() {
            let prices = [
                {
                    title: "전체 상품권 금액",
                    value: (this.isGained + this.gainable).format() + "원",
                },
            ];

            if (this.isGained) {
                prices.push({
                    title: "사용 상품권 금액",
                    value: (-this.isGained).format() + "원",
                });
            }

            return prices;
        },
    },
};
</script>

<style></style>
